var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"modal-title",attrs:{"data-v-b4af1080":""}},[_vm._v("Error")]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.errorMessage))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381e8553","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Generic/Error.vue
// module id = null
// module chunks = 